import React from 'react';
import CSCarousel from './components/CSCarousel';
import classNames from 'classnames';

export default function NewSlider() {
  const slidesData = [
    { id: 1, image: '/Homepage_Banner1.png' },
    { id: 2, image: '/Homepage_Banner2.png' },
    { id: 3, image: '/Homepage_Banner3.png' },
  ];

  return (
      <div
        className={classNames('col-12 p-0 m-0', {
          'fullHeight': window.innerWidth >= 640, 
          'fullHeightmb': window.innerWidth < 640, 
        })}
      >
      <CSCarousel slides={slidesData} />
      <h2 className="text-3xl font-bold text-center text-primary mt-3">CS Dynamo</h2>
      <div className="dynamo col-12 flex flex-wrap px-5 fade-in">
        <div className="col-12 md:col-6 flex flex-wrap justify-content-between mt-2">
          <div className="font-semibold text-lg">
            <h3 className="text-primary font-semibold text-base mb-2">CS Dynamo: Enterprise Solution Development</h3>
            <ul className="text-900 list-disc text-sm font-normal pl-5 space-y-2">
              <li className='mb-2'>Cutting-edge No Code Platform</li>
              <li className='mb-2'>Revolutionize workflow with agility</li>
              <li className='mb-2'>Rapid application development with intuitive drag-and-drop interface</li>
              <li className='mb-2'>No coding expertise required</li>
            </ul>

            <h3 className="text-primary font-semibold text-base mt-6 mb-2">Key Features</h3>
            <ul className="text-900 list-disc text-sm font-normal pl-5 space-y-2">
              <li className='mb-2'>Seamless integration of diverse functionalities</li>
              <li className='mb-2'>Streamline processes and enhance productivity</li>
              <li className='mb-2'>Speed and efficiency from concept to deployment</li>
              <li className='mb-2'>Scalable solutions evolving with your business</li>
            </ul>
            <h3 className="text-primary font-semibold text-base mt-6 mb-2">Collaborative Advantages</h3>
            <ul className="text-900 list-disc text-sm font-normal pl-5 space-y-2">
              <li className='mb-2'>Real-time collaboration for multiple contributors</li>
              <li className='mb-2'>Break down silos and foster a culture of innovation</li>
              <li className='mb-2'>Keep enterprise solutions up-to-date and agile</li>
            </ul>

            <h3 className="text-primary font-semibold text-base mt-6 mb-2">Digital Transformation Catalyst</h3>
            <ul className="text-900 list-disc text-sm font-normal pl-5 space-y-2">
              <li className='mb-2'>Empowerment for CRM systems, project management tools, and data analytics dashboards</li>
              <li className='mb-2'>Turn ideas into reality swiftly and seamlessly</li>
            </ul>

            <h3 className="text-primary font-semibold text-base mt-6 mb-2">CS Dynamo Impact</h3>
            <ul className="text-900 list-disc text-sm font-normal pl-5 space-y-2">
              <li className='mb-2'>Join forward-thinking enterprises embracing CS Dynamo</li>
              <li className='mb-2'>Transform business processes and reduce development cycles</li>
              <li className='mb-2'>Unlock unparalleled agility in enterprise solution creation</li>
            </ul>
          </div>
        </div>

        <div className="col-12 md:col-6 flex justify-content-center align-items-center mt-6 md:mt-0 fade-in">
          <img className="w-full cbimg" src="./website/controls.png" alt="CS Dynamo Controls" />
        </div>
      </div>

      <div className="col-12 flex flex-wrap bg-surface-ground align-items-center py-4 fade-in">
        <div className="col-12 md:col-4 text-5xl text-center font-semibold text-primary-light">
          <img className="w-full cbimg lg:w-8" src="./website/IndustrySolutionsBanner.png" alt="Industry Solutions" />
          <div className='text-primary'>Industry Solutions</div>
        </div>

        <div className="col-12 md:col-8 flex flex-wrap">
          {[
            { img: './website/Industry1.png', title: 'Manufacturing', description: 'Transform manufacturing with our cutting-edge software: real-time monitoring, efficiency, precision, scalability, and seamless integration.' },
            { img: './website/Education.png', title: 'Education', description: 'Transform education management with our integrated software solution. From enrollment to graduation, streamline processes, and empower institutions.' },
            { img: './website/Retail1.png', title: 'Retail', description: 'Elevate retail management with our integrated software. Enhance efficiency, optimize customer engagement, and boost profitability with our solution.' },
            { img: './website/RealEstate.png', title: 'Realty', description: 'Optimize your real estate business with our software, enhancing collaboration and efficiency across the project lifecycle from planning to completion.' },
          ].map((item, index) => (
            <div key={index} className="col-12 md:col-6 fade-in">
              <div className="card shadow-2 border-round text-center p-4 hover-animation">
                <img src={item.img} width="80" height="80" className="mb-4 cbimg" alt={item.title} />
                <span className="block text-xl font-bold text-900 mb-2">{item.title}</span>
                <p className="text-sm text-600">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
